import { Component, Input, OnInit } from '@angular/core';

declare const window: any;

@Component({
  selector: 'app-saves-list',
  templateUrl: './saves-list.component.html',
  styleUrls: ['./saves-list.component.scss']
})
export class SavesListComponent implements OnInit {
  private Game;
  public readonly AUTOSAVE_ID = 'GAME.AUTOSAVE';
  public readonly AUTOSAVE_NAME = 'Auto save';
  public AUTOSAVE;

  public readonly MANUAL_SAVE_ID = 'saveData';
  public readonly MANUAL_SAVE_NAME = 'Manual save';
  public MANUAL_SAVE;

  private updateAutoSaveDataLoop;

  @Input()
  set gameRef(game) {
    this.Game = game;
  }

  constructor() {
    window.time = this.msToTime;
  }

  ngOnInit() {
    this.MANUAL_SAVE = this.getSave(this.MANUAL_SAVE_ID);
    this.AUTOSAVE = this.getSave(this.AUTOSAVE_ID);
  }

  public getSave(aID) {
    const Save = JSON.parse(localStorage.getItem(aID));
    const Name = aID === this.AUTOSAVE_ID ? this.AUTOSAVE_NAME : this.MANUAL_SAVE_NAME;
    if (!Save) {
      return;
    }
    return {
      name: Name,
      save: Save,
      saveData: Save.saveDate,
      playtime: this.msToTime(Save.playtime),
      timeAscended: Save.ascension.times_ascended
    };
  }

  public msToTime(s) {
    const pad = (n, z = 2) => ('00' + n).slice(-z);
    // tslint:disable-next-line:no-bitwise
    return pad(s / 3.6e6 | 0) + ':' + pad((s % 3.6e6) / 6e4 | 0) + ':' + pad((s % 6e4 ) / 1000 | 0);
  }

  public onClickLoadSave(save) {
    this.Game.gameState = save;
    this.Game.start();
    this.Game.menuActive = false;
  }

}
